import { SkeletonBar, SkeletonBlock, SkeletonRoot } from './skeletonSection.style';

export const SkeletonSection = ({ minHeight = 600, label, testId }: { minHeight?: number; label?: string; testId?: string }) => (
    <SkeletonRoot
        aria-busy="true"
        aria-label={label ? `Loading ${label}` : 'Loading'}
        $minHeight={minHeight}
        data-testid={testId ?? 'skeleton-section'}
    >
        <SkeletonBar $width="40%" $height="28px" />
        <SkeletonBar $width="100%" />
        <SkeletonBar $width="70%" />
        <SkeletonBlock />
    </SkeletonRoot>
);
